import { Stack, Typography } from '@mui/material';
import { TableCustom } from 'app/components/elements/TableCustom';
import { useMemo } from 'react';
import { floordata } from 'types/floorplan';
import { PagingInfo } from 'types/paging';
import { HEADER_CLIENTS } from '../../hook';

type Props = {
  rows: floordata[];
  pagingInfo: PagingInfo;
  sort: {
    field: string;
    order: 'asc' | 'desc' | undefined;
  };

  onSort: (field: string) => void;
  onPageChange: (page: number) => void;

  onViewPlan: (href: string) => void;
  onViewDeficiencies: (href: string) => void;
  //   onGenerateReport: (row: Inspection) => void;
};

export const FloorPlanTable = ({
  rows,
  pagingInfo,
  sort,
  onSort,
  onPageChange,
  onViewPlan,
  onViewDeficiencies
  //   onGenerateReport
}: Props) => {
  const tableRows = useMemo(() => {
    return rows.map((item) => ({
      clientName: {
        value: <Typography>{item.client_name}</Typography>
      },
      locationpath: {
        value: <Typography>{item.locationPath}</Typography>
      },
      floorplan: {
        value: <Typography>{item.location_name}</Typography>
      },
      deficiencies: {
        value: <Typography>{'-'}</Typography>
      },
      status: {
        value: <Typography>{'-'}</Typography>
      },
      lastupdated: {
        value: <Typography>{'-'}</Typography>
      },

      actions: {
        value: (
          <Stack direction="row" spacing={2}>
            <Typography
              sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
              onClick={() =>
                onViewPlan(
                  `/pdfmapping/${item.client_name}/${item.client_id}/location/${item.location_id}/view`
                )
              }>
              View Plan
            </Typography>

            <Typography
              sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
              onClick={() =>
                onViewDeficiencies(
                  `/pdfmapping/${item.client_name}/${item.client_id}/location/${item.location_id}/view`
                )
              }>
              View Deficiencies
            </Typography>

            {/* 
          <Typography onClick={() => onGenerateReport(item)}>
            Generate Report
          </Typography> */}
          </Stack>
        )
      }
    }));
  }, [
    rows,
    onViewPlan,
    onViewDeficiencies
    //   onGenerateReport
  ]);
  return (
    <TableCustom
      headers={HEADER_CLIENTS}
      data={tableRows}
      sort={sort}
      onSortHeader={onSort}
      pagingInfo={pagingInfo}
      handleChangePage={onPageChange}
      handleChooseRow={() => {}}
      isScrollX
    />
  );
};
